module.exports = __webpack_public_path__ + "static/media/grid.b0bbd4f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/grid.svg
// module id = 279
// module chunks = 0